import { Route } from 'vue-router';

export default [{
  path: '/admin',
  name: 'Admin',
  component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Index.vue'),
  redirect: { name: 'Admin.WorkCorrection' },
  meta: {
    title: 'STEAM后台',
  },
  children: [
    {
      path: '/admin/work/correction/:id',
      name: 'Admin.WorkCorrection',
      component: () => import(/* webpackChunkName: "admin.work.correction" */ '../views/admin/WorkCorrection.vue'),
      props: (route: Route) => ({
        id: Number(route.params.id),
      }),
      meta: {
        title: '作品批改',
        needLogin: true,
      },
    },
  ],
}];
